/**
 * Created by Victor Rojo on 8/10/18.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import {NotificationMessage} from "./NotificationMessage";

@Injectable()
export class NotificationMessageService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  getLastWidgetNotifications(widgetId:string): Promise<any>{
    let url = this.basePath + "notification/widget/" + widgetId;
    return this.http.get(url)
      .toPromise()
      .then( res => res as NotificationMessage[])
      .catch( error => this.errorHandler(error) );
  }

  get(active=true, page=0, size=20 ): Promise<any>{
    let url = this.basePath + "notification/status";
    let params = new HttpParams();
    params = params.append('page', page.toString())
      .append('size', size.toString())
      .append('active', active.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as NotificationMessage[])
      .catch( error => this.errorHandler(error) );
  }

  ack(ids:string[]): Promise<any>{
    let url = this.basePath + "notification/web/ack";
    return this.http.post(url,ids, { responseType: 'text' })
      .toPromise()
      .catch( error => this.errorHandler(error) );
  }

}
